import { IState } from "@/typings";
export const state: IState = {
  routerArr: [],
  routerState: false,
  submitTableData: [],
};
